<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i>Product Offers
              <select v-model="catalog">
                <option disabled value="">Sort by Catalog</option>
                  <option value='20'>Devops</option>
                  <option value='31'>DevOps Android</option>
                  <option value='34'>DevOps iOS</option>
                  <option value='14'>Etisalat Emirates Android</option>
                  <option value='15'>Etisalat Emirates iOS</option>
                  <option value='16'>GPS Brasil Android</option>
                  <option value='17'>GPS Brasil iOS</option>
                  <option value='10'>Karta Android</option>
                  <option value='25'>Karta Automotive Demo</option>
                  <option value='30'>Karta Automotive Demo OSM</option>
                  <option value='21'>Karta Automotive Dev</option>
                  <option value='9'>Karta Dev Android</option>
                  <option value='13'>Karta Dev iOS</option>
                  <option value='12'>Karta iOS</option>
                  <option value='18'>Meo Drive Android</option>
                  <option value='19'>Meo Drive iOS</option>
                  <option value='32'>RandMcNally Android</option>
                  <option value='35'>RandMcNally Ces Android</option>
                  <option value='36'>RandMcNally Ces Tom Android</option>
                  <option value='33'>RandMcNally iOS</option>
                  <option value='37'>RandMcNally JIG Android</option>
                  <option value='38'>RandMcNally Official Android</option>
                  <option value='27'>UI Android</option>
                  <option value='28'>UI iOS</option>
                  <option value='22'>Veezit GPS Android</option>
              </select>
            </div>
            <div class="card-block">
              <table class="table table-bordered table-striped table-condensed">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Icon</th>
                    <th>Codename</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Catalog</th>
                    <th>Visibility</th>
                    <th>Size</th>
                    <th>Manage</th>
                    <th>Created at</th>
                  </tr>
                </thead>
                <tbody>
                  <loading-rows v-if="loading" cols='5'/>
                  <tr v-for="offer in offers" v-if="!loading">
                    <td>{{offer.id}}</td>
                    <td><product-offer-icon v-bind:icon="offer.icon" height="36px"></product-offer-icon></td>
                    <td><router-link :to="{ name: 'Offer', params: {id: offer.id} }">{{offer.codename}}</router-link></td>
                    <td>{{offer.name}}</td>
                    <td>{{offer.category_id}}</td>
                    <td>{{offer.catalog_id}}</td>
                    <td>
                      <span class="badge badge-success" v-if="offer.visibility === 'visible'">visible</span>
                      <span class="badge badge-default" v-else>not visible</span>
                    </td>
                    <td>
                      <span class="badge badge-success" v-if="offer.manage">manage</span>
                      <span class="badge badge-default" v-else>not manage</span>
                    </td>
                    <td>{{offer.size  | prettyBytes }}</td>
                    <td>{{offer.created_at | moment('LL')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    <div class="row">
      <div class="col-lg-12">
        <pagination v-bind:totalEntries="pagination.total_entries" v-bind:totalPages="pagination.total_pages" v-bind:currentPage="pagination.current_page"></pagination>
      </div>
    </div>

  </div>
</template>

<script>

import offers from 'services/productOffers'
import Pagination from 'components/Pagination'
import LoadingRows from 'components/LoadingRows'
import ProductOfferIcon from 'components/ProductOfferIcon'

export default {
  name: 'offers',
  created () {
    this.fetchData()
  },
  data () {
    return {
      offers: [],
      loading: false,
      pagination: {},
      catalog: '',
      uid: '',
      term: ''
    }
  },
  computed: {
    page () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return 1
    }
  },
  watch: {
    '$route': 'fetchData',
    'catalog': 'by_catalog'
  },
  components: {
    Pagination,
    LoadingRows,
    ProductOfferIcon
  },
  methods: {
    fetchData () {
      offers.all(this)
    },
    by_catalog () {
      this.offers = false

      if (this.previousRequest) {
        this.previousRequest.abort()
      }

      offers.search(this, null, null, this.catalog).then(
        response => {
          this.offers = response.body.data
          this.pagination = false
        },
        error => {
          console.log(error)
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/offers/Offers.vue